import { countByStatus } from '@/api/waybill';
import { getRouteListByBid, getProjectListByBid } from '@/api/common';
import { oilApplyCount, oilApplyExportUrl, oilApplyList } from '@/api/freight';
import { warning } from '@/api/home';

const storeModuleName = 'payOilStepModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'projectId',
      state: 'projectList',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: true,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'select',
      param: 'orderId',
      state: 'routeList',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNo',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'driverMobile',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNo',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'date-picker',
      param: 'applyTime',
      value: [],
      valueType: 'date',
      label: '申请时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['applyTimeStr', 'applyTimeEnd'],
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '支付状态',
      name: 'payStatus',
      value: '',
      selectList: [
        {
          value: '',
          label: '全部',
          isActive: true,
          countName: 'totalCount',
          count: 0,
        },
        {
          value: 'PAYING',
          label: '待审核',
          isActive: false,
          countName: 'payingCount',
          count: 0,
        },
        {
          value: 'SUCCESS',
          label: '已同意',
          isActive: false,
          countName: 'successCount',
          count: 0,
        },
        {
          value: 'REFUSE',
          label: '已拒绝',
          isActive: false,
          countName: 'refuseCount',
          count: 0,
        },
      ],
    },
  ],
  // 导出
  isExport: {
    isShow: true,
    // method: 'get',
    url: oilApplyExportUrl,
  },
  // 页码 + 参数
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '申请信息',
        prop: 'message',
        width: 130,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-message',
      },
      {
        label: '运单信息',
        width: 160,
        prop: 'waybill',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybill',
      },
      {
        label: '申请金额（元）',
        width: 90,
        prop: 'money',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-money',
      },
      {
        label: '审核状态',
        prop: 'payStatus',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payStatus',
      },
      {
        label: '运力信息',
        prop: 'capacity',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-capacity',
      },
      {
        label: '操作',
        width: 100,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  companyList: [],
  projectList: [],
  routeList: [],
  report: {},
  sumdata: {},
};
// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    // 获取统计信息
    const { data } = await oilApplyList(Object.assign({}, params, context.state.postParams));
    data.list = data.records;
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    delete params['size'];
    delete params['page'];
    oilApplyCount(Object.assign({}, params)).then(res => {
      context.commit('updateReport', Object.assign({}, res.data));
    });
    delete params['payStatus'];
    oilApplyCount(Object.assign({}, params)).then(res => {
      for (const resKey in res.data) {
        const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
          return selectItem.countName === resKey;
        });
        if (index > -1) {
          context.commit('updateButtonValueFromIndex', {
            index: index,
            value: res.data[resKey],
          });
        }
      }
    });
    const res1 = await warning({ businessId: context.state.parameters[0].value });
    if (res1.code == 200) {
      context.commit('updatesumdata', res1.data);
    }
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await countByStatus({
      businessId: context.state.parameters[0].value,
      waybillType: 'ONESTOP_REALTIME',
    });
    context.commit('updateState', {
      key: 'waybillStatus',
      value: data.waybillStatusCountDtoList,
    });
    data &&
      data.waybillStatusCountDtoList.forEach(item => {
        const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
          return selectItem.value === item.waybillStatus;
        });
        context.commit('updateButtonValueFromIndex', {
          index,
          value: item.count,
        });
      });
  },
  // 获取企业列表
  getCompanyList: (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    const { code, data } = await getProjectListByBid({
      businessId: context.state.parameters[0].value,
      keyword,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.name;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'projectList',
        value: data.list,
      });
    }
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    const { code, data } = await getRouteListByBid({
      businessId: context.state.parameters[0].value,
      projectId: context.state.parameters[2].value,
      lineType: 'transfer',
      keyword,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.orderName;
        item.value = item.orderId;
      });
      context.commit('updateState', {
        key: 'routeList',
        value: data.list,
      });
    }
  },
};

const mutations = {
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    console.log(state, payload);
    state.parameters[payload.index].value = payload.value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    specialData.value = payload.value;
    specialData.selectList.forEach(item => {
      item.isActive = item.value === payload.value;
    });
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新统计信息
  updateReport(state, payload) {
    state.report = payload;
  },
  updatesumdata(state, payload) {
    state.sumdata = payload;
  },
  // 重置所有状态
  initFilter(state) {
    state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
    state.isSpecialButton.forEach(item => {
      item.value = '';
      item.selectList.forEach(select => {
        select.isActive = item.value.includes(select.value);
      });
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
